import React from "react";
import banner from '../assets/banner.jpg'
import fb from '../assets/fb.png';
import ig from '../assets/ig.png';
import lin from '../assets/lin.png';
import tw from '../assets/tw.png';
import yt from '../assets/yt.png';

const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

const socialLinks = [
  { href: "https://www.instagram.com/tieupsolutions/", icon: ig, alt: "Instagram", className: "w-7 h-7" },
  { href: "https://www.facebook.com/tieupsolutions/", icon: fb, alt: "Facebook", className: "w-7 h-7" },
  { href: "https://www.linkedin.com/company/tieupsolutions/", icon: lin, alt: "LinkedIn", className: "w-5 h-5" },
  { href: "https://twitter.com/tieupsolutions", icon: tw, alt: "Twitter", className: "w-5 h-5" },
  { href: "https://www.youtube.com/@TieupSolutions", icon: yt, alt: "YouTube", className: "w-7 h-7" },
];

const HeroSection = () => {
  return (
    <section className="relative w-full min-h-[520px] flex flex-col items-center justify-center bg-gray-100 overflow-hidden">
      {/* Background image placeholder */}
      <img src={banner} alt="Shuttlecock banner" className="absolute inset-0 w-full h-full object-cover opacity-90" />
      {/* Premium Deep Navy overlay for premium feel */}
      <div className="absolute inset-0 bg-[#0a183d] bg-opacity-80 z-0" />
      <div className="relative z-10 flex flex-col items-center justify-center text-center px-4 w-full max-w-5xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-extrabold text-[#ffd700] mb-2 leading-tight drop-shadow-lg">ShuttleClash 2025<br /><span className="font-extrabold">Organized by Tieup Solutions</span></h1>
        <p className="text-xl md:text-2xl text-white mb-8 max-w-3xl mx-auto drop-shadow-lg">Join us for a premier badminton event designed to bring together competitive spirit, sportsmanship, and community. ShuttleClash 2025 offers an inclusive platform for players across all levels to showcase their talent and engage in spirited matches.</p>
        <div className="flex flex-col md:flex-row gap-4 mb-4 justify-center">
          <button
            onClick={() => scrollToSection('register')}
            className="px-8 py-3 bg-red-500 text-white rounded-md font-semibold text-lg shadow hover:bg-red-600 transition"
          >
            Register Now
          </button>
          <button
            onClick={() => scrollToSection('category')}
            className="px-8 py-3 bg-white text-red-500 border border-red-500 rounded-md font-semibold text-lg shadow hover:bg-red-50 transition"
          >
            Category
          </button>
        </div>
        {/* Mobile horizontal social icons row below hero content */}
        <div className="md:hidden flex flex-col items-center mt-6">
          <span className="mb-2 text-white text-base">Follow Us:</span>
          <div className="flex flex-row items-center justify-center gap-4">
            {socialLinks.map(link => (
              <a key={link.alt} href={link.href} target="_blank" rel="noopener noreferrer">
                <img src={link.icon} alt={link.alt} className={link.className} />
              </a>
            ))}
          </div>
        </div>
      </div>
      {/* Desktop vertical social icons */}
      <div className="hidden md:flex flex-col items-center absolute right-12 top-1/2 -translate-y-1/2 z-10">
        <span className="mb-2 text-white text-base" style={{writingMode: 'vertical-rl', transform: 'rotate(180deg)'}}>Social Links</span>
        <div className="w-px h-24 bg-gray-300 mb-2" />
        {socialLinks.map((link, idx) => (
          <a key={link.alt} href={link.href} target="_blank" rel="noopener noreferrer" className={idx !== socialLinks.length - 1 ? "mb-3" : ""}>
            <img src={link.icon} alt={link.alt} className={link.className} />
          </a>
        ))}
      </div>
    </section>
  );
};

export default HeroSection; 